import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import React, { useState } from "react";

export const CustomerBusinessPartnerDetailPublish = () => {
    const [key, setKey] = useState('기본정보');

    return (
        <>
            <div className="content_wrap mb-15px">
                <div className="fiter_top">
                    <h3 className="filter_heading">거래처 상세보기</h3>
                    <div className="filter_toolbar">
                        {key == "기본정보" && <React.Fragment>
                            <button className="btn btn-outline-primary w-100px h-38px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt="" />목록</button>
                            <button className="btn btn-secondary w-100px h-38px">수정</button>
                        </React.Fragment>}

                        {key == "출하정보" && <React.Fragment>
                            <label className="form-label m-0 w-120px">상태</label>
                            <select className="form-select h-34px w-150px">
                                <option>비활성</option>
                            </select>
                            <button className="btn btn-info w-80px h-34px">저장</button>
                        </React.Fragment>}

                        {key == "이전 결제 건" && <React.Fragment><button className="btn btn-info w-80px h-34px">저장</button></React.Fragment>}

                        {key == "PTA 레벨" && <React.Fragment>
                            <label className="form-label m-0 w-120px">상태</label>
                            <select className="form-select h-34px w-150px">
                                <option>비활성</option>
                            </select>
                            <button className="btn btn-info w-80px h-34px">저장</button>

                            <button className="btn btn-outline-primary w-100px h-38px ms-40px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt="" />목록</button>
                            <button className="btn btn-secondary w-100px h-38px">수정</button>
                        </React.Fragment>}

                        {key == "연락처" && <React.Fragment>
                            <label className="form-label m-0 w-120px">상태</label>
                            <select className="form-select h-34px w-150px">
                                <option>비활성</option>
                            </select>
                            <button className="btn btn-info w-80px h-34px">저장</button>

                            <button className="btn btn-outline-primary w-100px h-38px ms-40px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt="" />목록</button>
                        </React.Fragment>}

                        {key == "주소" && <React.Fragment>
                            <label className="form-label m-0 w-120px">상태</label>
                            <select className="form-select h-34px w-150px">
                                <option>비활성</option>
                            </select>
                            <button className="btn btn-info w-80px h-34px">저장</button>

                            <button className="btn btn-outline-primary w-100px h-38px ms-40px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt="" />목록</button>
                        </React.Fragment>}
                    </div>
                </div>
                <h5 className="subheading">거래처 정보</h5>
                <div className="table_scroll mb-0">
                    <table className="table table-bordered my_table table_detail">
                        <tbody>
                            <tr>
                                <th style={{ width: "16.66%" }}>거래처명</th>
                                <td colSpan={3}>MDS 테크</td>
                            </tr>
                            <tr>
                                <th style={{ width: "16.66%" }}>생성일자</th>
                                <td style={{ width: "33.34%" }}>2024-05-05</td>
                                <th style={{ width: "16.66%" }}>생성자</th>
                                <td>SYSTEM</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="position-relative">
                {/*
                <div className="d-flex align-items-center btn_top r-0">
                    <button className="btn btn-primary w-100px">주소 생성</button>
                    <button className="btn btn-outline-dark w-100px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt="" />주소 생성</button>
                </div>
                */}
                <Tabs
                    defaultActiveKey="기본정보"
                    transition={false}
                    className="mytab_pills mb-15px"
                    variant="pills"
                    onSelect={(k) => setKey(k)}
                >
                    <Tab eventKey="기본정보" title="기본정보">
                        <div className="content_wrap">
                            <h5 className="subheading mt-0">회사정보</h5>
                            <div className="table_scroll mb-0">
                                <table className="table table-bordered my_table table_detail">
                                    <tbody>
                                        <tr>
                                            <th style={{ width: "16.66%" }}>회사명(국문)</th>
                                            <td style={{ width: "33.34%" }}>MDS테크</td>
                                            <th style={{ width: "16.66%" }}>발송방법</th>
                                            <td>택배</td>
                                        </tr>
                                        <tr>
                                            <th>회사명(영문)</th>
                                            <td>MDSTECH</td>
                                            <th>연락처</th>
                                            <td>
                                                <select className="form-select w-250px">
                                                    <option>경쟁업체</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>소속분류</th>
                                            <td>
                                                <select className="form-select w-250px">
                                                    <option>중견기업</option>
                                                </select>
                                            </td>
                                            <th>소재지</th>
                                            <td>
                                                <select className="form-select w-250px">
                                                    <option>경기</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>산업구분</th>
                                            <td colSpan={3}></td>
                                        </tr>
                                        <tr>
                                            <th>사업자 등록증</th>
                                            <td>
                                                <div className="td_list_files_wbtn">
                                                    <div className='td_list_files'>
                                                        <button className="btn btn-link" href={void (0)}>첨부파일1.pdf<img src={process.env.PUBLIC_URL + "/assets/images/icon_del_file.png"} alt="" /></button>
                                                        <button className="btn btn-link" href={void (0)}>첨부파일1.pdf<img src={process.env.PUBLIC_URL + "/assets/images/icon_del_file.png"} alt="" /></button>
                                                        <button className="btn btn-link" href={void (0)}>첨부파일1.pdf<img src={process.env.PUBLIC_URL + "/assets/images/icon_del_file.png"} alt="" /></button>
                                                        <button className="btn btn-link" href={void (0)}>첨부파일1.pdf<img src={process.env.PUBLIC_URL + "/assets/images/icon_del_file.png"} alt="" /></button>
                                                        <button className="btn btn-link" href={void (0)}>첨부파일1.pdf<img src={process.env.PUBLIC_URL + "/assets/images/icon_del_file.png"} alt="" /></button>
                                                    </div>
                                                    <button className="btn btn-outline-secondary f-13 px-0 w-80px h-30px" href={void (0)}>파일 업로드</button>
                                                </div>
                                            </td>
                                            <th>사업자등록번호</th>
                                            <td>111-1111111-1111111</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h5 className="subheading mt-20px">ERP 거래처정보</h5>
                            <div className="table_scroll mb-0">
                                <table className="table table-bordered my_table table_detail">
                                    <tbody>
                                        <tr>
                                            <th style={{ width: "16.66%" }}>ERP 코드</th>
                                            <td style={{ width: "33.34%" }}>310</td>
                                            <th style={{ width: "16.66%" }}>수금방법</th>
                                            <td>현금</td>
                                        </tr>
                                        <tr>
                                            <th>ERP 거래처</th>
                                            <td>(주)MDSTECH</td>
                                            <th>여신한도</th>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <th>대표자</th>
                                            <td>이창열, 이정승</td>
                                            <th>수금예정월</th>
                                            <td>11월</td>
                                        </tr>
                                        <tr>
                                            <th>대표전화</th>
                                            <td>02)000-0000</td>
                                            <th>수금예정일</th>
                                            <td>11월</td>
                                        </tr>
                                        <tr>
                                            <th>주소1</th>
                                            <td>서울특별시 금천구 000 0000</td>
                                            <th>수금예정일</th>
                                            <td>10일</td>
                                        </tr>
                                        <tr>
                                            <th>주소2</th>
                                            <td colSpan={3}>서울특별시 금천구 000 0000</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Tab>
                    <Tab eventKey="출하정보" title="출하정보">
                        <div className="content_wrap">
                            <h5 className="subheading mt-0">상세정보</h5>
                            <div className="table_scroll mb-0">
                                <table className="table table-bordered my_table table_detail">
                                    <tbody>
                                        <tr>
                                            <th style={{ width: "16.66%" }}>담당자</th>
                                            <td style={{ width: "33.34%" }}>이소희</td>
                                            <th style={{ width: "16.66%" }}>수주유형<span className="required">*</span></th>
                                            <td>로열티매출(세금계산서)</td>
                                        </tr>
                                        <tr>
                                            <th>납품처<span className="required">*</span></th>
                                            <td>MDSTECH</td>
                                            <th>산업구분</th>
                                            <td>IT</td>
                                        </tr>
                                        <tr>
                                            <th>매출처<span className="required">*</span></th>
                                            <td>
                                                <select className="form-select w-250px">
                                                    <option>중견기업</option>
                                                </select>
                                            </td>
                                            <th>Application</th>
                                            <td>IPC</td>
                                        </tr>
                                        <tr>
                                            <th>환율 지정 조건</th>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <select className="form-select">
                                                        <option>일평균</option>
                                                    </select>
                                                    <select className="form-select ms-5px">
                                                        <option>최초 고시</option>
                                                    </select>
                                                    <select className="form-select ms-5px">
                                                        <option>송금 보낼 때</option>
                                                    </select>
                                                </div>
                                            </td>
                                            <th>Vat 구분<span className="required">*</span></th>
                                            <td>과세(세금계산서)</td>
                                        </tr>
                                        <tr>
                                            <th>세금계산서 담당자</th>
                                            <td>홍길동</td>
                                            <th>수신자</th>
                                            <td>박길동</td>
                                        </tr>
                                        <tr>
                                            <th>발송지 주소</th>
                                            <td colSpan={3}>서울특별시 금천구 000 0000</td>
                                        </tr>
                                        <tr>
                                            <th>메모</th>
                                            <td colSpan={3}>거래명세서 동봉</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Tab>
                    <Tab eventKey="이전 결제 건" title="이전 결제 건">
                        <div className="content_wrap">
                            <div className="table_top">
                                <h6 className="table_stats">결제 건 목록(<span>13</span>건)</h6>
                                <div className="table_toolbar">
                                    <button className="btn btn-info w-110px">새창으로 보기</button>
                                </div>
                            </div>

                            <div className="table_scroll">
                                <table className="table table-bordered my_table">
                                    <thead>
                                        <tr>
                                            <th>구매일자<img src={process.env.PUBLIC_URL + "/assets/images/icon-table-sort-down.png"} alt="" />​</th>
                                            <th>제품<img src={process.env.PUBLIC_URL + "/assets/images/icon-table-sort-down.png"} alt="" />​</th>
                                            <th>규격<img src={process.env.PUBLIC_URL + "/assets/images/icon-table-sort-down.png"} alt="" />​</th>
                                            <th>수량​</th>
                                            <th colSpan={3}>환율​</th>
                                            <th>배송방법​</th>
                                            <th>상태​</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, index) => (
                                            <tr>
                                                <td className="text-center">2024-05-05</td>
                                                <td className="text-end">S1-WIN Emb Compact 7 C7E​​</td>
                                                <td className="text-center">MUV-1234​</td>
                                                <td className="text-center">1​</td>
                                                <td className="text-center">일평균​</td>
                                                <td className="text-center">최초고시​</td>
                                                <td className="text-center">송금 보낼 때​</td>
                                                <td className="text-center">택배​</td>
                                                <td className="text-center">배송 중​</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="pagination-container">
                                <ul>
                                    <li className="pg_nav">
                                        <img
                                            src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                            alt="First Page"
                                            className=""
                                        />
                                    </li>
                                    <li className="pg_nav">
                                        <img
                                            src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                            alt="Previous Page"
                                            className=""
                                        />
                                    </li>
                                    <li className="active">1</li>
                                    <li className="">2</li>
                                    <li className="">3</li>
                                    <li className="">4</li>
                                    <li className="">5</li>
                                    <li className="pg_nav">
                                        <img
                                            src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                            alt="Next Page"
                                            className=""
                                        />
                                    </li>
                                    <li className="pg_nav">
                                        <img
                                            src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                            alt="Last Page"
                                            className=""
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </Tab>
                    <Tab eventKey="PTA 레벨" title="PTA 레벨">
                        <div className="content_wrap">
                            <h5 className="subheading mt-0">문서정보</h5>
                            <div className="table_scroll mb-20px">
                                <table className="table table-bordered my_table table_detail">
                                    <tbody>
                                        <tr>
                                            <th style={{ width: "16.66%" }}>CLA 문서</th>
                                            <td style={{ width: "33.34%" }}><button className="btn btn-link" href={void (0)}>OEM CLA_MDS테크.pdf</button></td>
                                            <th style={{ width: "16.66%" }}>CLA Number</th>
                                            <td>123456</td>
                                        </tr>
                                        <tr>
                                            <th>Parent CompanyID</th>
                                            <td></td>
                                            <th></th>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <th>CompanyID</th>
                                            <td></td>
                                            <th>Company Legal Name</th>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="table_top">
                                <h6 className="table_stats">결제 건 목록(<span>13</span>건)</h6>
                                <div className="table_toolbar">
                                </div>
                            </div>

                            <div className="table_scroll">
                                <table className="table table-bordered my_table">
                                    <thead>
                                        <tr>
                                            <th>No<img src={process.env.PUBLIC_URL + "/assets/images/icon-table-sort-down.png"} alt="" /></th>
                                            <th>Product Group</th>
                                            <th>Item Name</th>
                                            <th>Pricing Group</th>
                                            <th>Currency Type</th>
                                            <th>Pricing Tier</th>
                                            <th>Price</th>
                                            <th>ERP코드</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">1</td>
                                                <td className="text-center">IoT</td>
                                                <td>Windows Svr Std Ent DC</td>
                                                <td className="text-center">USD</td>
                                                <td className="text-center">B</td>
                                                <td className="text-center">50</td>
                                                <td className="text-center">310</td>
                                                <td></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="pagination-container">
                                <ul>
                                    <li className="pg_nav">
                                        <img
                                            src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                            alt="First Page"
                                            className=""
                                        />
                                    </li>
                                    <li className="pg_nav">
                                        <img
                                            src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                            alt="Previous Page"
                                            className=""
                                        />
                                    </li>
                                    <li className="active">1</li>
                                    <li className="">2</li>
                                    <li className="">3</li>
                                    <li className="">4</li>
                                    <li className="">5</li>
                                    <li className="pg_nav">
                                        <img
                                            src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                            alt="Next Page"
                                            className=""
                                        />
                                    </li>
                                    <li className="pg_nav">
                                        <img
                                            src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                            alt="Last Page"
                                            className=""
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </Tab>
                    <Tab eventKey="연락처" title="연락처">
                        <div className="content_wrap">
                            <div className="fiter_top">
                                <h3 className="filter_heading">연락처 검색</h3>
                                <div className="filter_toolbar"></div>
                            </div>
                            <div className="row">
                                <div className="col-6">
                                    <div className="frm_row search justify-content-start">
                                        <label for="" className="form-label frm_label">검색어</label>
                                        <select className="form-select w-150px">
                                            <option>이름</option>
                                        </select>
                                        <input type="text" className="form-control w-250px me-0" />
                                        <button className="btn btn-info btn_search">
                                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                                        </button>
                                    </div>
                                </div>
                                <div className="col-6"></div>
                            </div>
                        </div>
                        <div className="content_wrap">
                            <div className="table_top">
                                <h6 className="table_stats">연락처 목록(<span>13</span>건)</h6>
                                <div className="table_toolbar">
                                    <div className="text_num_contacts">연락처 수<span>3건</span></div>
                                </div>
                            </div>

                            <div className="table_scroll">
                                <table className="table table-bordered my_table">
                                    <thead>
                                        <tr>
                                            <th>
                                                <div className="checkbox_outer">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                    />
                                                </div>
                                            </th>
                                            <th>이름<img src={process.env.PUBLIC_URL + "/assets/images/icon-table-sort-down.png"} alt="" />​</th>
                                            <th>직함<img src={process.env.PUBLIC_URL + "/assets/images/icon-table-sort-down.png"} alt="" /></th>
                                            <th>부서<img src={process.env.PUBLIC_URL + "/assets/images/icon-table-sort-down.png"} alt="" />​</th>
                                            <th>팀<img src={process.env.PUBLIC_URL + "/assets/images/icon-table-sort-down.png"} alt="" />​</th>
                                            <th>산업구분<img src={process.env.PUBLIC_URL + "/assets/images/icon-table-sort-down.png"} alt="" />​</th>
                                            <th>근무처 전화​</th>
                                            <th>휴대폰​</th>
                                            <th>회사 이메일​</th>
                                            <th>상태<img src={process.env.PUBLIC_URL + "/assets/images/icon-table-sort-down.png"} alt="" />​</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <div className="checkbox_outer">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                        />
                                                    </div>
                                                </td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="pagination-container">
                                <ul>
                                    <li className="pg_nav">
                                        <img
                                            src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                            alt="First Page"
                                            className=""
                                        />
                                    </li>
                                    <li className="pg_nav">
                                        <img
                                            src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                            alt="Previous Page"
                                            className=""
                                        />
                                    </li>
                                    <li className="active">1</li>
                                    <li className="">2</li>
                                    <li className="">3</li>
                                    <li className="">4</li>
                                    <li className="">5</li>
                                    <li className="pg_nav">
                                        <img
                                            src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                            alt="Next Page"
                                            className=""
                                        />
                                    </li>
                                    <li className="pg_nav">
                                        <img
                                            src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                            alt="Last Page"
                                            className=""
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </Tab>
                    <Tab eventKey="주소" title="주소">
                        <div className="content_wrap">
                            <div className="fiter_top">
                                <h3 className="filter_heading">연락처 검색</h3>
                                <div className="filter_toolbar"></div>
                            </div>
                            <div className="row">
                                <div className="col-6">
                                    <div className="frm_row search justify-content-start">
                                        <label for="" className="form-label frm_label">검색어</label>
                                        <select className="form-select w-150px">
                                            <option>이름</option>
                                        </select>
                                        <input type="text" className="form-control w-250px me-0" />
                                        <button className="btn btn-info btn_search">
                                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                                        </button>
                                    </div>
                                </div>
                                <div className="col-6"></div>
                            </div>
                        </div>
                        <div className="content_wrap">
                            <div className="table_top">
                                <h6 className="table_stats">주소 목록(<span>13</span>건)</h6>
                                <div className="table_toolbar">
                                </div>
                            </div>

                            <div className="table_scroll">
                                <table className="table table-bordered my_table">
                                    <thead>
                                        <tr>
                                            <th>
                                                <div className="checkbox_outer">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                    />
                                                </div>
                                            </th>
                                            <th>이름<img src={process.env.PUBLIC_URL + "/assets/images/icon-table-sort-down.png"} alt="" />​</th>
                                            <th>우편번호</th>
                                            <th>주소1​</th>
                                            <th>주소2​</th>
                                            <th>생성자</th>
                                            <th>생성일자​</th>
                                            <th>상태<img src={process.env.PUBLIC_URL + "/assets/images/icon-table-sort-down.png"} alt="" />​</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <div className="checkbox_outer">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                        />
                                                    </div>
                                                </td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="pagination-container">
                                <ul>
                                    <li className="pg_nav">
                                        <img
                                            src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                            alt="First Page"
                                            className=""
                                        />
                                    </li>
                                    <li className="pg_nav">
                                        <img
                                            src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                            alt="Previous Page"
                                            className=""
                                        />
                                    </li>
                                    <li className="active">1</li>
                                    <li className="">2</li>
                                    <li className="">3</li>
                                    <li className="">4</li>
                                    <li className="">5</li>
                                    <li className="pg_nav">
                                        <img
                                            src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                            alt="Next Page"
                                            className=""
                                        />
                                    </li>
                                    <li className="pg_nav">
                                        <img
                                            src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                            alt="Last Page"
                                            className=""
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </Tab>

                </Tabs>
            </div>
        </>
    );
}